import React, { useEffect } from "react";
import InitializeSurvey from "./initialializeSurvey";
import { useLocation } from "react-router-dom";

import Axios from "axios";
/* Chages for test */
// import data from "../../18db774d-4c99-499e-b435-a4677930f32c.json";

export default function GetSurveyComponent({
  setPollName,
  Name,
  items,
  setItems,
  actualQuestioId,
  setactualQuestion,
  setPoll,
  poll,
}) {
  let query = useQuery();

  useEffect(() => {
    // 🔴 VALIDACIÓN DE PARÁMETROS OBLIGATORIOS
    const requiredParams = [
      "pollguid",
      "pollid",
      "studentid",
      "curseid",
      "professorid",
    ];

    const hasMissingParams = requiredParams.some(
      (p) => !query.get(p) || query.get(p) === "",
    );

    if (hasMissingParams) {
      const url =
        window.location.protocol +
        "//" +
        window.location.host +
        "/evaluacion-docente/";
      // const url = "http://localhost:88/evaluacion-docente/";
      // 🔥 REDIRECT A PHP
      window.location.href = url + "control.php";
      return;
    }

    const addGeneralInformation = () => {
      const aux = items;
      aux.CourseName = query.get("nombre_curso");
      aux.pollguid = query.get("pollguid");
      aux.ObjectToSave.professor_Evaluation_Poll_GUID = query.get("pollid");
      aux.ObjectToSave.studentID = query.get("studentid");
      aux.ObjectToSave.classScheduleID = query.get("curseid");
      aux.ObjectToSave.professorID = query.get("professorid");
      setItems(aux);
    };

    addGeneralInformation();

    /* Changes for test */
    // const doARequest = async (pollRoute) => {
    //   setPoll(data.poll.questions.question);
    //   setactualQuestion(data.poll.questions.question?.[0].id);
    //   setPollName(data.poll.name);
    // };

    const doARequest = async (pollRoute) => {
      const response = await Axios({
        url: window.location.protocol + "//" + window.location.host + pollRoute,
      });
      setPoll(response.data.poll.questions.question);
      setactualQuestion(response.data.poll.questions.question?.[0].id);
      setPollName(response.data.poll.name);
    };

    const fetchData = async () => {
      try {
        await doARequest(
          "/evaluacion-docente/data/" + query.get("pollid") + ".json",
        );
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [items, setItems, query, setPoll, setPollName, setactualQuestion]);

  return (
    <div>
      <InitializeSurvey
        setPollName={setPollName}
        Name={Name}
        items={items}
        setItems={setItems}
        actualQuestioId={actualQuestioId}
        setactualQuestion={setactualQuestion}
        setPoll={setPoll}
        poll={poll}
      />
    </div>
  );
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
